// import { createSlice } from "@reduxjs/toolkit";

// // add to local storage
// const initialState = {
//   cartItems: localStorage.getItem("cartItems")
//     ? JSON.parse(localStorage.getItem("cartItems"))
//     : [],
//   shippingInfo: localStorage.getItem("shippingInfo")
//     ? JSON.parse(localStorage.getItem("shippingInfo"))
//     : {},
// };

// export const cartSlice = createSlice({
//   initialState,
//   name: "cartSlice",
//   reducers: {
//     setCartItem: (state, action) => {
//       const item = action.payload;

//       const isItemExist = state.cartItems.find(
//         (i) => i.product === item.product
//       );

//       if (isItemExist) {
//         state.cartItems = state.cartItems.map((i) =>
//           i.product === isItemExist.product ? item : i
//         );
//       } else {
//         state.cartItems = [...state.cartItems, item];
//       }

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     removeCartItem: (state, action) => {
//       state.cartItems = state?.cartItems?.filter(
//         (i) => i.product !== action.payload
//       );

//       localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
//     },
//     clearCart: (state, action) => {
//      localStorage.removeItem("cartItems");
//      state.cartItems = [];
//     },
//     saveShippingInfo: (state, action) => {
//       state.shippingInfo = action.payload;

//       localStorage.setItem("shippingInfo", JSON.stringify(state.shippingInfo));
//     },
//   },
// });

// export default cartSlice.reducer;

// export const { setCartItem, clearCart, removeCartItem, saveShippingInfo } =
//   cartSlice.actions;


import { createSlice } from "@reduxjs/toolkit";

// Initial state with localStorage hydration
const initialState = {
  cartItems: localStorage.getItem("cartItems")
    ? JSON.parse(localStorage.getItem("cartItems"))
    : [],
  shippingInfo: localStorage.getItem("shippingInfo")
    ? JSON.parse(localStorage.getItem("shippingInfo"))
    : {},
};

export const cartSlice = createSlice({
  name: "cartSlice",
  initialState,
  reducers: {
    setCartItem: (state, action) => {
      const item = action.payload;
    
      const index = state.cartItems.findIndex(
        (i) => i.product === item.product
      );
    
      if (index !== -1) {
        // Replace existing item (including its quantity)
        state.cartItems[index] = item;
      } else {
        // Add new item
        state.cartItems.push(item);
      }
    
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    updateCartItemQty: (state, action) => {
      const { productId, qty } = action.payload;

      const item = state.cartItems.find((i) => i.product === productId);
      if (item) {
        item.quantity = qty > item.stock ? item.stock : qty;
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    removeCartItem: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (i) => i.product !== action.payload
      );

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    clearCart: (state) => {
      state.cartItems = [];
      localStorage.removeItem("cartItems");
    },

    saveShippingInfo: (state, action) => {
      state.shippingInfo = action.payload;
      localStorage.setItem("shippingInfo", JSON.stringify(state.shippingInfo));
    },
  },
});

export const {
  setCartItem,
  updateCartItemQty,
  removeCartItem,
  clearCart,
  saveShippingInfo,
} = cartSlice.actions;

export default cartSlice.reducer;

